<template>
  <div class="storagePoolsDetail">
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-card>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </b-card>
      </template>
      <div>
        <div class="contentsCollapse d-flex flex-column">
          <div class="blockContentCollapse">
            <VmInfoCard :title="detailData.name" :isLongCard="false">
            </VmInfoCard>

            <KeyValueList
              :items="keyValue"
              class="blockContentAreaSmall"
              listStyle="light"
              :isLongList="true"
            />
          </div>
        </div>

        <FullWidthList
          class="mt-10"
          :mainHeader="mainHeaderList"
          :subHeader="subHeaderList"
          :items="itemList"
        />
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'

export default {
  name: 'StoragePoolsDetail',
  data() {
    return {
      loading: false,
      detailData: '',
      keyValue: [],
      resetForm: false,
      confirmCreate: false,
      mainHeaderList: [],
      subHeaderList: [],
      itemList: [],
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'servers.storagePools',
        route: '/my-cloud/storage-pools',
      },
    ])
    this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
      menuList: [
        {
          title: 'servers.myCloud',
        },
        {
          title: 'servers.storagePools',
          route: '/my-cloud/storage-pools',
        },
        { title: 'global.detail' },
      ],
      showSearch: false,
      showDetailButton: false,
    })
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.loading = true
      this.getDetailInfo()
        .then((res) => {
          this.setDetailInfo(res)
        })
        .catch(() => {
          this.redirectList()
        })
    },
    getDetailInfo() {
      return new Promise((resolve, reject) => {
        ApiService.get(`iaas/storage-pools/${this.$route.params.id}`)
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    redirectList() {
      this.$router.push('/my-cloud/storage-pools')
    },
    setDetailInfo(res) {
      if (res && res.data) {
        this.detailData = res.data
        this.setKeyValueList()
        this.setTabs()
        this.loading = false
      } else {
        this.redirectList()
      }
    },
    setKeyValueList() {
      this.keyValue = [
        {
          keyGlobal: 'global.name',
          value: this.detailData.name ? this.detailData.name : '',
        },
        {
          keyGlobal: 'global.currencyCode',
          value: this.detailData.currency_code
            ? this.detailData.currency_code
            : '',
        },
        {
          keyGlobal: 'global.hourlyPrice',
          value: this.detailData.hourly_price,
        },
      ]
    },
    setTabs() {
      this.mainHeaderList = [
        { id: 'storageVolumes', name: 'Storage Volumes' },
        { id: 'storageMembers', name: 'Storage Members' },
      ]
      this.subHeaderList = [
        {
          id: 'storageVolumesList',
          mainId: 'storageVolumes',
          name: this.$t('global.list'),
        },
        {
          id: 'storageMembersList',
          mainId: 'storageMembers',
          name: this.$t('global.list'),
        },
      ]
      this.itemList = [
        {
          mainId: 'storageVolumes',
          subId: 'storageVolumesList',
          componentName: 'StorageVolumesList',
        },
        {
          mainId: 'storageMembers',
          subId: 'storageMembersList',
          componentName: 'StorageMembersList',
        },
      ]
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.closeDetail()
        this.getDetail()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
  },
  components: {
    // Forms
    CreateStreamingCluster: () =>
      import('@/components/forms/CreateStreamingCluster'),
    // Components
    VmInfoCard: () => import('@/components/detail/VmInfoCard'),
    KeyValueList: () => import('@/components/detail/KeyValueList'),
    FullWidthList: () => import('@/components/detail/FullWidthList'),
  },
}
</script>

<style lang="scss" scoped>
.storagePoolsDetail {
  .contentsCollapse {
    background: #ffffff;
    border-radius: 12px;
  }
  .blockContentCollapse {
    background: #ffffff;
    border-radius: 12px;
  }
}
</style>
